import React from "react";
import PolicyLayout from "../components/PolicyLayout";

const termsContent = [
  {
    id: "acceptance-of-terms",
    title: "Acceptance Of Terms",
    content:
      "By browsing Tanuraaga, creating an account, placing an order, or using our services, you agree to these terms and conditions. If you do not agree, please do not use the website.",
  },
  {
    id: "product-information",
    title: "Product Information",
    content:
      "We make every effort to display saree details, fabric descriptions, colors, blouse piece information, prices, and availability accurately. Slight variations may occur due to lighting, photography, and device screen settings.",
  },
  {
    id: "orders-and-acceptance",
    title: "Orders And Acceptance",
    content:
      "An order placed on the website is subject to product availability, payment confirmation, and verification. Tanuraaga reserves the right to cancel or refuse any order due to stock issues, pricing errors, suspicious activity, or incorrect customer information.",
  },
  {
    id: "pricing-and-payment",
    title: "Pricing And Payment",
    content:
      "All prices are displayed in Indian Rupees unless otherwise stated. Prices, offers, shipping charges, and taxes may change without prior notice. Orders are processed only after successful payment or confirmed cash-on-delivery eligibility where available.",
  },
  {
    id: "shipping-and-delivery",
    title: "Shipping And Delivery",
    content:
      "Delivery timelines are estimates and may vary based on location, courier availability, festivals, weather, or operational delays. Customers must provide complete and correct delivery details to avoid failed or delayed delivery.",
  },
  {
    id: "returns-and-refunds",
    title: "Returns And Refunds",
    content:
      "Returns, exchanges, and refunds are handled according to our Customer Refund Policies. Sarees must meet eligibility conditions, and requests must be raised within the stated return window.",
  },
  {
    id: "customer-account",
    title: "Customer Account",
    content:
      "Customers are responsible for maintaining account confidentiality and ensuring that personal, contact, billing, and shipping details are accurate. Tanuraaga is not responsible for issues caused by incorrect information shared by the customer.",
  },
  {
    id: "intellectual-property",
    title: "Intellectual Property",
    content:
      "All website content, including images, logos, text, layouts, graphics, product presentation, and brand elements, belongs to Tanuraaga or its licensors and may not be copied, reused, or reproduced without permission.",
  },
  {
    id: "limitation-of-liability",
    title: "Limitation Of Liability",
    content:
      "Tanuraaga is not liable for indirect losses, courier delays, technical interruptions, payment gateway issues, color perception differences, or damages caused by misuse, alteration, washing, or improper care of sarees.",
  },
  {
    id: "changes-to-terms",
    title: "Changes To Terms",
    content:
      "Tanuraaga may update these terms from time to time. Updated terms will apply once published on the website. Continued use of the website means you accept the revised terms.",
  },
];

const Termsconditions = () => (
  <PolicyLayout
    activeLabel="Terms & Conditions"
    className="terms-policy-page"
    title="Terms & Conditions"
    intro={{
      title: "Welcome To Tanuraaga",
      content:
        "These terms explain the rules for using Tanuraaga and shopping our Indian-style women’s saree collections. Please read them carefully before placing an order.",
    }}
    sections={termsContent}
  />
);

export default Termsconditions;
